import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcGiftFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.554a2.438 2.438 0 0 0-4.125 1.759V5c0 .332.066.649.187.938H4.5a2 2 0 0 0-2 2V10c0 .301.067.587.186.843.128.275.43.407.733.407H20.58c.304 0 .605-.132.733-.407.12-.256.186-.542.186-.843V7.938a2 2 0 0 0-2-2h-3.562c.12-.29.187-.606.187-.938v-.687A2.437 2.437 0 0 0 12 2.553m8.25 10.196h-7.5V22h4.75a2.75 2.75 0 0 0 2.75-2.75zm-9 9.25v-9.25h-7.5v6.5A2.75 2.75 0 0 0 6.5 22zm0-17.687a.937.937 0 1 0-1.875 0V5a.937.937 0 1 0 1.875 0zm2.438 1.625c.517 0 .937-.42.937-.938v-.687a.937.937 0 1 0-1.875 0V5c0 .518.42.938.938.938",
    clipRule: "evenodd"
  }));
}
var IcGiftFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcGiftFill));

export { IcGiftFill as I };
